import { Tooltip } from '@mui/material';

import { useLanguage } from '../../../hooks';
import { SingleListType, StyleSheet } from '../../../types/list';

interface ListCompProps {
  userList: SingleListType;
}

const styles: StyleSheet = {
  mainContainer: {},
  container: {
    fontSize: 12,
    display: 'flex',
    padding: '5px',
    maxWidth: '20vw',
  },
  tag: {
    marginRight: '5px',
    color: '#757575',
  },
  text: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
};

const ListComponent = ({ userList }: ListCompProps) => {
  const { name, description, code } = userList;
  const lang = useLanguage();

  return (
    <div style={styles.mainContainer}>
      <div style={styles.container}>
        <div style={styles.tag}>{lang.listManager.name}</div>
        <Tooltip
          title={name}
          placement={'bottom'}
        >
          <div style={styles.text}>{name}</div>
        </Tooltip>
      </div>
      {description && (
        <div style={styles.container}>
          <div style={styles.tag}>{lang.listManager.description}</div>
          <Tooltip
            title={description}
            placement={'bottom'}
          >
            <div style={styles.text}>{description}</div>
          </Tooltip>
        </div>
      )}
      <div style={styles.container}>
        <div style={styles.tag}>{lang.listManager.code}</div>
        <Tooltip
          title={code}
          placement={'bottom'}
        >
          <div style={styles.text}>{code}</div>
        </Tooltip>
      </div>
    </div>
  );
};

export default ListComponent;
